import React from "react";
import Alert from "./alert.jsx";

/**
 *  @returns {React.JSX.Element} React function component
 */
function ErrorFallback() {
  return (
    <div className="fr-flex fr-flex-col fr-w-full fr-h-screen fr-items-center fr-justify-center">
      <Alert
        type="error"
        title="Unrecoverable error encountered"
        message="The quiz application encountered an error and was not able to render. The issue has been logged and will be resolved as soon as possible."
      />
    </div>
  );
}

export default ErrorFallback;
